export class TenementExchangeOtpModel {
  userId!: string;
  loginOtp!: string;
  firstApplicantloginOtp!: string;
  secondApplicantloginOtp!: string;
  firstApplicationNo: string;
  secondApplicationNo: string;
}
